import { ButtonLearnMore } from '@components/Button';
import { Col, Row } from 'antd';
import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import Image from 'next/image';
const CardService = ({
  thumbnail,
  title,
  description,
  linkLearnMore,
  isRowReverse = false,
  childServices = [],
  id,
}) => {
  return (
    <div className="card-service" id={id}>
      <Row
        gutter={[
          {
            xxl: 84,
            md: 24,
          },
          20,
        ]}
        className={classNames('card-service__row', {
          'row-reverse': isRowReverse,
        })}
      >
        <Col xs={24} md={9} className="column-img">
          <div className="card-service__thumbnail">
            {/* <video autoPlay muted loop playsInline>
              <source src={thumbnail} type="video/mp4" />
            </video> */}
            <Image src={thumbnail} layout="fill" quality={100} objectFit="contain" />
          </div>
        </Col>
        <Col xs={24} md={15} className="column-text">
          <h2 className="card-service__title">{title}</h2>
          <div className="card-service__description">{description}</div>

          {linkLearnMore && (
            <Link href={linkLearnMore}>
              <a className="card-service__link">
                <ButtonLearnMore />
              </a>
            </Link>
          )}
          <Row
            gutter={[
              {
                xxl: 48,
                md: 24,
              },
              {
                md: 24,
                sm: 18,
                xs: 18,
              },
            ]}
            className="row-child-service"
          >
            {childServices.map((service, index) => (
              <Col xs={24} md={12} key={index}>
                <Link href={service.link}>
                  <a>
                    <div className="item-service">
                      <img src="/icons/icon-orange-tick.svg" alt="Right Arrow" />
                      <div className="name-service">{service.name}</div>
                    </div>
                  </a>
                </Link>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default CardService;
